import React from "react";
import { NavLink } from "react-router-dom";

export default function GrayBanner(props: any) {
  return (
    <div className={`${props.padding ? "p-4" : ""} w-full`}>
      <div className="bg-main-gray p-10">
        <div className="mx-auto max-w-[800px] py-12 flex flex-col sm:flex-row gap-10">
          <div className="whitespace-nowrap h-full">
            <p className=" text-gray-300 text-sm font-bold">{props.tag}</p>
            <p className="font-headings text-3xl">{props.title}</p>
            <button
              type="button"
              className={`mt-6 px-3 py-1 text-white font-body-flex bg-${props.button.color}`}
            >
              <NavLink to="/contact-us">{props.button.text}</NavLink>
            </button>
          </div>
          <div className="flex flex-col gap-4">{props.content}</div>
        </div>
      </div>
    </div>
  );
}
